import get from 'lodash/get';
import { batch } from 'react-redux';
export default function updateAlertsActionCreator(userDuck, personalization, savedInventoryDuck) {
  return _ref => {
    let {
      bookmarkId,
      enabledFlag,
      targets,
      inventoryId,
      phone
    } = _ref;
    return async (dispatch, getState) => {
      // get current saved search object
      if (targets.length > 0 && bookmarkId) {
        let updateEmailAlerts;
        if (targets[0].toLowerCase() === 'sms' && enabledFlag) {
          dispatch({
            type: savedInventoryDuck.types.SET_ANIMATED_BUTTON_STATE,
            payload: 'loading'
          });
          const phoneNumber = phone && phone.replace(/[^0-9]/g, '');
          const currentPhoneNumber = get(getState(), 'user.profile.phone', null);
          const hasValidPhone = await personalization.validatePhone(currentPhoneNumber, phoneNumber);
          if (hasValidPhone.success) {
            dispatch(userDuck.creators.setAlertsError(null));
            updateEmailAlerts = await personalization.updateAlerts({
              bookmarkId,
              enabledFlag,
              targets,
              phone: phoneNumber
            });
          } else {
            dispatch(userDuck.creators.setAlertsError('Please enter a valid phone number.'));
            dispatch({
              type: savedInventoryDuck.types.SET_ANIMATED_BUTTON_STATE,
              payload: ''
            });
          }
        } else {
          updateEmailAlerts = await personalization.updateAlerts({
            bookmarkId,
            enabledFlag,
            targets
          });
        }
        if (updateEmailAlerts.responseCode === '200') {
          const bookmarks = get(getState(), 'user.bookmarks.inventoryBookmarks', {});
          const updatedBookmarks = {
            ...bookmarks
          };
          const targetsCopy = targets[0].toLowerCase() === 'sms' ? 'Text' : 'Email';
          const bookmarkKey = `has${targetsCopy}Alerts`;
          dispatch({
            type: savedInventoryDuck.types.SET_ANIMATED_BUTTON_STATE,
            payload: 'loaded'
          });
          let message = '';
          updatedBookmarks[inventoryId] = {
            ...bookmarks[inventoryId],
            [bookmarkKey]: enabledFlag
          };
          if (enabledFlag) {
            dispatch(userDuck.creators.addEmailAlertsItem(bookmarkId));
            message = `${targetsCopy} alerts enabled.`;
          } else {
            dispatch(userDuck.creators.removeEmailAlertsItem(bookmarkId));
            message = `${targetsCopy} alerts disabled.`;
          }
          dispatch(userDuck.creators.setGlobalAlert({
            key: 'alertsSuccess',
            message
          }));
          dispatch(userDuck.creators.setInventoryBookmarks(updatedBookmarks));
          setTimeout(() => {
            batch(() => {
              dispatch(userDuck.creators.setAlertsModal(false));
              dispatch({
                type: savedInventoryDuck.types.SET_ANIMATED_BUTTON_STATE,
                payload: ''
              });
            });
          }, 1000);
        } else {
          dispatch({
            type: savedInventoryDuck.types.SET_ANIMATED_BUTTON_STATE,
            payload: ''
          });
        }
      }
    };
  };
}